<div class="goreact-modal download-pwa-dialog ngx-dialog">
	<div class="goreact-modal-header">
		<h4 class="modal-title" translate="modal-download-pwa-title"></h4>
		<button
			class="close-btn"
			type="button"
			[attr.aria-label]="'common_close' | translate"
			(click)="close()">
			<i class="ficon-app-x"></i>
		</button>
	</div>
	<div class="goreact-modal-body" tabindex="0">
		<div translate="modal-download-pwa-text"></div>
		<div class="content-container">
			<div class="mobile-section" *ngIf="!UADetect.browserDetector.isMobileSafari()">
				<div class="mobile-title" translate="modal-download-pwa-img1-title"></div>
				<img alt="PWA Android" class="asset-img" src="https://staticassets.goreact.com/android-pwa.svg">
			</div>
			<div class="mobile-section">
				<div class="mobile-title" translate="modal-download-pwa-img2-title"></div>
				<img alt="PWA iOS" class="asset-gif" src="https://staticassets.goreact.com/ios-pwa-2.gif">
			</div>
		</div>
	</div>
	<div class="goreact-modal-footer">
		<a
			href="https://support.echo360.com/hc/en-us/articles/38604330940301-GoReact-Mobile-Version"
			class="link-btn"
			target="_blank"
			translate="common_more-info-capitalized">
		</a>
		<button
			type="button"
			class="goreact-btn primary-btn"
			(click)="close()"
			translate="common_close">
		</button>
	</div>
</div>
